import { render, staticRenderFns } from "./ErrorsTable.vue?vue&type=template&id=4280fa40&scoped=true&"
import script from "./ErrorsTable.vue?vue&type=script&lang=js&"
export * from "./ErrorsTable.vue?vue&type=script&lang=js&"
import style0 from "./ErrorsTable.vue?vue&type=style&index=0&id=4280fa40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4280fa40",
  null
  
)

export default component.exports